import { render, staticRenderFns } from "./camp_tab_component.vue?vue&type=template&id=0016d0c3&scoped=true&"
import script from "./camp_tab_component.vue?vue&type=script&lang=js&"
export * from "./camp_tab_component.vue?vue&type=script&lang=js&"
import style0 from "./camp_tab_component.vue?vue&type=style&index=0&id=0016d0c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016d0c3",
  null
  
)

export default component.exports